<div *ngIf="group.length" class="flex items-center gap-6 py-9">
     <div #scrollableGroupList class="scrollable-section flex gap-4 overflow-x-scroll w-full">

        <!-- Group Card -->
        <button 
            *ngFor="let item of group" 
            id="{{item.id}}"
            class="relative flex flex-col items-start gap-4 p-6 min-w-[380px] border border-dashboard-400 rounded-xl transition-all group overflow-hidden"
            [ngClass]="groupCardStyle(item, 'background')"
            (click)="(activeGroup && activeGroup.id !== item.id) ? chooseGroup(item) : ''" 
        >
            <div class="flex items-center gap-4 truncate">
                <mat-icon 
                    [svgIcon]="item.description || getIconSolution(item)" 
                    class="icon-size-[30px]"
                    [ngClass]="groupCardStyle(item, 'icon')"
                ></mat-icon>
                <p 
                    class="font-ibm_sans font-bold text-[32px] truncate"
                    [ngClass]="groupCardStyle(item, 'text')"
                >{{item.notes}}</p>
            </div>
            <div class="flex items-center justify-between w-full">
                <p class="headline-6 capitalize {{activeGroup && activeGroup.id === item.id ? 'text-white' : ''}}">{{item.role_name | transloco}}</p>
                <p class="headline-6 capitalize {{activeGroup && activeGroup.id === item.id ? 'text-white' : ''}}">{{getSolutionName(item.solution)}}</p>
            </div>
         </button>
     </div>

     <!-- Additional Buttons -->
     <div class="flex flex-col items-center gap-4">
        <div class="flex justify-center items-center w-16 h-10 rounded-full bg-dashboard-400 overflow-hidden">
            <button class="arrow-button" (mousedown)="startScroll('left')" (mouseup)="stopScroll('left')" (mouseleave)="cancelIfHolding('left')">
                <mat-icon class="icon-size-1">arrow_left</mat-icon>
            </button>
            <div class="h-full w-[1px] bg-dashboard-300"></div>
            <button class="arrow-button" (mousedown)="startScroll('right')" (mouseup)="stopScroll('right')" (mouseleave)="cancelIfHolding('right')">
                <mat-icon class="icon-size-1">arrow_right</mat-icon>
            </button>
        </div>

        <!-- <button mat-icon-button class="bg-dashboard-400" (mousedown)="startScrollRight()" (mouseup)="stopScrollRight()" (mouseleave)="stopScrollRight()">
            <mat-icon [svgIcon]="'arrow_forward'" class="text-dashboard-50"></mat-icon>
        </button> -->

        <div class="flex justify-center " *ngIf="canCreateUser">
            <button mat-icon-button (click)="drawerAddOpened = true; drawerAddType = 'create'" class="bg-dashboard-400 sm:scale-100 scale-75">
                <mat-icon class="text-2xl text-white" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            </button>
            
        </div>
        <app-dropdown-menu 
            *ngIf="activeGroup"
            class="bg-dashboard-400 rounded-full w-10 h-10"
            [iconCustomClass]="'text-white'"
            [activeGroup]="activeGroup" 
            [data]="activeGroup"
            [buttonList]="['show_group_id', 'edit_group', 'leave_group', 'delete_group']"
        ></app-dropdown-menu>
     </div>
</div>

<app-drawer 
    *transloco="let t"
    [opened]="drawerAddOpened" 
    (cancel)="cancelAddDrawer()" 
    [title]="drawerAddType ? t(drawerAddType) + ' ' + t('Group'): t('Add Group')" 
    [image]="'/images/background/background.jpg'"
>
    <app-group-add-form [type]="drawerAddType" (changeType)="drawerAddType = $event" (cancel)="cancelAddDrawer()"></app-group-add-form>
</app-drawer>